import { render } from "./PlanChangeModal.vue?vue&type=template&id=504fdd72&scoped=true"
import script from "./PlanChangeModal.vue?vue&type=script&lang=js"
export * from "./PlanChangeModal.vue?vue&type=script&lang=js"

import "./PlanChangeModal.vue?vue&type=style&index=0&id=504fdd72&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504fdd72"]])

export default __exports__